import { createIcon } from '@chakra-ui/icons';

const EnvelopeIcon = createIcon({
  displayName: 'RegularIcon',
  viewBox: '0 0 16 16',
  path: (
    <>
      <path
        d="M13.3333 2H2.66659C1.93125 2 1.33325 2.598 1.33325 3.33333V12.6667C1.33325 13.402 1.93125 14 2.66659 14H13.3333C14.0686 14 14.6666 13.402 14.6666 12.6667V3.33333C14.6666 2.598 14.0686 2 13.3333 2ZM2.66659 12.6667V3.33333H13.3333L13.3346 12.6667H2.66659Z"
        fill="currentColor"
      />
      <path d="M4 4.66675H12V6.00008H4V4.66675ZM4 7.33341H12V8.66675H4V7.33341ZM4 10.0001H8V11.3334H4V10.0001Z" fill="currentColor" />
    </>
  ),
});

export default EnvelopeIcon;
